// extracted by mini-css-extract-plugin
export default {"container":"HeroSection_container__l4lg+","heading":"HeroSection_heading__kcR+q","gradientAnimation":"HeroSection_gradientAnimation__hRZMT"};